<template>
    <div class="mobile-subnav--slider">
        <NavSliderItem
            v-for="item in items"
            :key="item.id"
            :isActive="activeItemId === item.id"
            v-bind="item"
        />
    </div>
</template>

<script>
    import NavSliderItem from './NavSliderItem';

    export default {
        props: {
            items: {
                type: Array,
                required: true,
            },
            activeItemId: {
                type: [String, Number],
                required: true,
            }
        },
        components: {
            NavSliderItem,
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/mobile/components/NavSlider/NavSlider.vue